module.exports = __webpack_public_path__ + "static/media/home-header-image.9ac1cfe1.jpg";